// extracted by mini-css-extract-plugin
module.exports = {"Favor":"Favorites_Favor__3Cae9","Favor_visible":"Favorites_Favor_visible__3LcWQ"};